import React from 'react';
import './videos.scss';

function Video({ data }) {
  const { head, videoSrc, videoTitle } = data;
  return (
    <div className="videos__video">
      <h4>{head}'s Story</h4>
      <div className="videos__video__player">
        <iframe
          src={videoSrc}
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
          title={videoTitle}
        ></iframe>
      </div>
    </div>
  );
}

export default Video;
